export enum AppPaths {
	LOGIN = 'login',
	RESET_PASSWORD = 'reset-password',
	SET_PASSWORD = 'set-password',

	ADMINS = 'admins',

	PRICE_GROUPS = 'price-groups',

	ATTRIBUTES = 'attributes',
	ATTRIBUTE_VALUES = 'attribute-values',

	PRODUCT_MODULES = 'product-modules',

	PRESETS = 'presets',

	PRODUCT_MODULE_COLLECTIONS = 'product-module-collections',
	MATERIALS = 'materials',
	MODELS = 'models',
	CONTENT = 'content',
}
